import React, { Component, Fragment } from 'react';
import { Button, TableBody, TableRow, TableCell } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import Dialog from '../../../../commonModules/interface/Dialog';
import PopUp from '../../../../commonModules/interface/PopUp';
import { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { toast } from 'react-toastify';

class FormPrepa extends Component {
    state = {
        view: "form",
        nature: "payg",
        prepa:{
            id: ""
        }
      }
    validatePrepa = async (prepaID) => {
        console.log('====================================');
        console.log("SUBMIT VALIDATE PREPA", {prepaID});
        console.log('====================================');
        const sale = {
            prepa_id:prepaID,
            new_nature:this.state.nature,
            date:new Date()
        }
        await this.props.validatePrepa(sale)
                            
        if(this.props.STATE.sales.error){
            console.log("ERROR", this.props.STATE.sales.error);
            this.setState({
                sending: false,
            })
            let errorMessage = "Une erreur est survenue";
            if (typeof this.props.STATE.sales.error === 'string') {
                errorMessage = this.props.STATE.sales.error;
            } else if (this.props.STATE.sales.error && typeof this.props.STATE.sales.error === 'object') {
                errorMessage = this.props.STATE.sales.error.message || this.props.STATE.sales.error.error || JSON.stringify(this.props.STATE.sales.error);
            }
            toast.error(errorMessage)
        } else{
            console.log("prepa submit ok");
            // success 
            toast.info("Opération enregistrée avec succès")
            this.props.handleClose()
        }
        
    }

  
    // handleChangePrepa = async  (e) => {  
    //     const field = e.target.name
    //     const value = e.target.value
        
    //     this.setState({
    //         [field]:value            
    //     })
    // }
    handleSelectNature = (option, name) => {
        console.log("SELECT HANDLE",{option, name});            
        this.setState({
            nature:option.value,
            natureDisplay:option
        })
    } 

    render() {
        const { prepa, CLIENTS, SHOPS, PRODUCTS, SALES } = this.props;
        let client = CLIENTS[prepa.client_ref || prepa.sale_paygo_id]
        const prepaID = prepa.id
        console.log('====================================');
        console.log({prepa});
        console.log('====================================');
        let fieldList = [
            {name: "client_lastname", label:"Nom", display:client.client_lastname},
            {name: "client_firstname", label:"Prénom", display:client.client_firstname},
            {name: "client_address", label:"Adresse", display:client.client_address},
            {name: "client_city", label:"Ville", display:client.client_city},
            {name: "client_country", label:"Pays", display:client.client_country},
            {name: "client_tel", label:"Téléphone", display:client.client_tel},
            {name: "client_email", label:"Email", display:client.client_email},
            {name: "shop", label:"Shop", display:SHOPS[prepa.shop_id]},
            {name: "nature", label:"Nature", display:this.state.nature},
            {name: "transport", label:"Coût Transport", display:prepa.transport},
            {name:"taxes", label:"Autres Taxes", display:prepa.taxes},        
            {name:"products"},   
            {name:"comments", label:"Commentaires",display:prepa.comments},
            {name:"discount", label:"Réduction Totale", display:prepa.discount},
            {name:"total", label:"Montant Total", display:prepa.total},
        ]

        
        return (
            <Fragment>
            {this.state.view === "form" &&
                <Dialog
                    block={true}
                    close={this.props.handleClose}
                    title="Valider la Vente"
                    submitAction={()=>this.setState({view: "confirm"})}
                >
                    <InputSelectMagasin
                        options={[
                            {value:"payg", label:"Pay As You Go"},
                            {value:"installation", label:"Installation"},
                            {value:"vente", label:"Vente"},
                        ]}
                        value={this.state.natureDisplay}
                        onChange={(option)=>this.handleSelectNature(option,"nature")}
                        label="Nature"
                        // error={this.state.errors.nature}
                        // isOptionDisabled={(option)=>option.disabled === true}
                    /> 
                </Dialog>
            }
            {this.state.view === "confirm" &&
            <PopUp
                title="Confirmation"
                submitAction={() => this.validatePrepa(prepaID)}
                close={() => this.setState({ view:"form" })}
            >
                <TableLayout>
                    <TableBody>
                    {fieldList.map( field => {
                        if(client[field.name]){
                            return (
                                <TableRow>
                                    <TableCell>{field.label}</TableCell>
                                    <TableCell colSpan={3}>{field.display}</TableCell>
                                </TableRow>
                            )
                        } else if(SALES[prepaID][field.name]){
                            if (field.name === "products"){
                                return SALES[prepaID].products.map( prod => (
                                    <TableRow>
                                        <TableCell>{PRODUCTS[prod.product_id].name}</TableCell>
                                        <TableCell>
                                            {`${prod.quantity} x ${(prod.price / prod.quantity)} `}
                                            {PRODUCTS[prod.product_id].prix_venteHT !== parseFloat(prod.price) && 
                                                <i className="linethrough">{PRODUCTS[prod.product_id].prix_venteHT}</i>
                                            }
                                        </TableCell>
                                        
                                        <TableCell><b>{prod.price}</b></TableCell>
                                    </TableRow>
                                ))
                            } else {
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell colSpan={3}>{field.display}</TableCell>
                                    </TableRow>
                                )
                            }
                        } 
                    })

                    }                            
                    </TableBody>
                </TableLayout>
            </PopUp>
               
            }
            </Fragment>
            
        );
    }
}

export default FormPrepa;